<template lang="">
    <div class="default-section">

        <!-- <div class="cv-viewer-header">
             <div class="heading-section fw-bold" style="color:var(--primary);">
            CV Builder
            </div>
            <div class="header-button">
            <button class="btn btn-default" style="background:var(--primary);color:white;">Export PDF</button>
            </div>
        </div> -->
       
        <div class="cv-sections">
            <PersonalInfoSection :fullname="personalInfo.fullname"
                                :title="personalInfo.title"
                               :phone="personalInfo.phone"
                                :url="personalInfo.url"
                                :email="personalInfo.email"/>
            <PersonalSummarySection/>
            <SkillsSection v-if="skills.length != 0"/>
            <WorkExperienceSection v-if="experiences.length != 0"/>
            <EducationSection v-if="educations.length != 0"/>
            <CertificatesSection v-if="achievements.length != 0"/>
            <ReferencesSection v-if="references.length != 0"/>
        </div>
    </div>
</template>
<script>
    import PersonalInfoSection from './CVViewerSections/PersonalInfoSection.vue';
    import PersonalSummarySection from './CVViewerSections/PersonalSummarySection.vue';
    import SkillsSection from './CVViewerSections/SkillsSection.vue';
    import WorkExperienceSection from './CVViewerSections/WorkExperienceSection.vue';
    import EducationSection from './CVViewerSections/EducationSection.vue';
    import CertificatesSection from './CVViewerSections/CertificatesSection.vue';
    import ReferencesSection from './CVViewerSections/ReferencesSection.vue';
export default {
    components:{
        PersonalSummarySection,
        SkillsSection,
        WorkExperienceSection,
        EducationSection,
        CertificatesSection,
        PersonalInfoSection,
        ReferencesSection
    },
    props:{
        cv:{
            type: Object,
            default: () => null

        }
    },
    data(){
        return{
             user:{
                    fullname:"",
                    phone:"",
                    title:"",
                    website:"",
                    email:""              
                }
        }
    },
    created(){
         const authUser = this.$store.getters['auth/getAuthenticatedUser'];
        if (authUser) {
            this.user.fullname = authUser.fullname || "";
            this.user.phone = authUser.phone || "";
            this.user.title = authUser.title || "";
            this.user.website = authUser.website || "";
            this.user.email = authUser.email || "";
        }
    },
    computed:{
        skills(){
            var skls = this.$store.getters["cvbuilder/getCVInformation"]?.skills || [];
            return skls;
        },
        references(){
             var refs = this.$store.getters["cvbuilder/getCVInformation"]?.references || [];
            return refs;
        },
         experiences(){
            var works = this.$store.getters["cvbuilder/getCVInformation"]?.workExperiences || [];
            return works;
        },
         educations(){
            var eds = this.$store.getters["cvbuilder/getCVInformation"]?.educations || [];
            return eds;
        },
         achievements(){
            var eds = this.$store.getters["cvbuilder/getCVInformation"]?.achievements || [];
            return eds;
        },
        personalInfo(){
            var info = this.$store.getters["cvbuilder/getCVInformation"]?.personalInfo || [];
            return info;
        }
    }
}
</script>
<style scoped>

    .default-section{
        margin:0.4rem 1rem;
    }

    .heading-section{
        color:var(--tertiary);
    }

    .cv-sections{
        padding:0.8rem;
        /* border:1px solid var(--darkgrey2); */
        border-radius:8px;
        background-color:white;
        color:black!important;
    }

    .cv-viewer-header{
        display: flex;
        justify-content: space-between;
    }

    .header-button{
        display: flex;
        align-items: center;
    }

    @media(max-width:768px) {
         .cv-viewer-header{
        display: none;
        }

        .cv-sections{
       
        padding:0.3rem;
    }
    }
</style>